export default {
  sophiaText: undefined,
  searchType: undefined,
};
